import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import pages from "../../../constants/menu";
import { FERADEL_LOGO_PATH } from "../../../constants/brand";
import MenuItems from "./items"; 
import "./style.css";

export class Mobile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showing: false
    }
  }
  doToggle = (e) => {
    this.setState({
      showing: !Boolean(this.state.showing)
    })
  }

  onPermitted = (named) => {
    const permissions = (Array.isArray(named)) ? named : [named];
    return (this.props.auth?.permissions || []).some(item => permissions.includes(item));
  }

  render() {
    if (!this.props.auth) return;
    return (
      <>
        <nav className="topnav">
          <div className="mobileNavHeader">
            <Link to="/dashboard" aria-label="Feradel Dashboard" className="mobileLogoLink">
              <img src={FERADEL_LOGO_PATH} alt="Feradel" className="mobileLogo" />
            </Link>
            <button
              type="button"
              className="mobileNavButton"
              onClick={this.doToggle}
              aria-label="Toggle navigation"
              aria-expanded={this.state.showing}
              aria-controls="mobileMenuLinks"
            >
              <span className="mobileNavButtonLines" />
              <span className="mobileNavButtonLines" />
              <span className="mobileNavButtonLines" />
            </button>
          </div>
          <ul className="mobileMenuLinks" id="mobileMenuLinks" style={{display: this.state.showing ? "block": "none"}}>
            <MenuItems items={pages[0].contains.items} onPermitted={this.onPermitted} />
          </ul>
        </nav>
      </>
    )
  }
}

Mobile.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    profile: state.licensee.profile,
  };
};

export default connect(mapStateToProps)(Mobile);
